(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("kgUtil", [], factory);
	else if(typeof exports === 'object')
		exports["kgUtil"] = factory();
	else
		root["kgUtil"] = factory();
})(window, function() {
return 